import React, { PureComponent } from 'react';

import { ButtonIcon } from 'components/button';
import { I18n } from 'components/translate';
import PropTypes from 'prop-types';

export default class SubtitleActionButton extends PureComponent {
  static propTypes = {
    label: PropTypes.string,
    name: PropTypes.string,
    onClick: PropTypes.func
  };

  render() {
    const { label, name, onClick } = this.props;

    return (
      <ButtonIcon
        className={`subtitle__action subtitle__action__${name}`}
        icon={name}
        transparent
        onClick={onClick}
      >
        <I18n label={label} />
      </ButtonIcon>
    );
  }
}
